export const Partners = (props) => {
  const partners = props.data || []

  // Map each partner to a Font Awesome icon + accent colour
  const iconMap = {
    'MNRE':        { icon: 'fa fa-institution', color: '#138808' },
    'Adani Solar': { icon: 'fa fa-sun-o',        color: '#f5a623' },
    'Waari Solar': { icon: 'fa fa-bolt',          color: '#3b9eff' },
    'Havells':     { icon: 'fa fa-plug',          color: '#e63946' },
    'Luminous':    { icon: 'fa fa-lightbulb-o',  color: '#f5a623' },
    'SMA':         { icon: 'fa fa-bar-chart',     color: '#3b9eff' },
  }

  return (
    <div id='partners'>
      {/* Top wave — light (Portfolio) → dark navy (Partners) */}
      <div className='partners-wave-top'>
        <svg viewBox='0 0 1440 70' preserveAspectRatio='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M0,0 C360,70 1080,0 1440,40 L1440,0 L0,0 Z' fill='var(--clr-bg)' />
        </svg>
      </div>

      <div className='container'>
        <div className='row'>
          <div className='col-md-10 col-md-offset-1 section-title text-center'>
            <h2>Certifications &amp; Partners</h2>
            <p>We hold all mandatory government certifications and partner exclusively with India's most trusted solar brands.</p>
          </div>
        </div>
        <div className='partners-strip'>
          {partners.map((p, i) => {
            const meta = iconMap[p.name] || { icon: 'fa fa-check-circle', color: '#3b9eff' }
            return (
              <div key={i} className='partner-tile'>
                <div className='partner-tile-icon' style={{ '--p-color': meta.color }}>
                  <i className={meta.icon}></i>
                </div>
                <span className='partner-tile-name'>{p.name}</span>
              </div>
            )
          })}
        </div>
      </div>

      {/* Bottom wave — dark navy (Partners) → light (Testimonials) */}
      <div className='partners-wave-bottom'>
        <svg viewBox='0 0 1440 70' preserveAspectRatio='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M0,40 C360,0 1080,70 1440,20 L1440,70 L0,70 Z' fill='var(--clr-bg)' />
        </svg>
      </div>
    </div>
  )
}
